import React, { Reducer, useContext, useEffect } from "react";
import { createContext, useReducer } from "react";
import { Dispatch, ProviderProps } from "../../common/types";
import { ThemeReducer, IThemeState, initialThemeState } from "./reducer";
import { ThemeAction } from "./action";
import { LOCAL_STORAGE_KEYS } from "../../common/constants";
import { useTranslation } from "react-i18next";

const ThemeContext = createContext<
  { state: IThemeState; dispatch: Dispatch<ThemeAction> } | undefined
>(undefined);

const getInitialThemeState = (): IThemeState => {
  const storedThemeState = localStorage.getItem(LOCAL_STORAGE_KEYS.THEME);
  return storedThemeState ? JSON.parse(storedThemeState) : initialThemeState;
};

export const ThemeProvider: React.FC<ProviderProps> = (
  props: ProviderProps
) => {
  const { i18n } = useTranslation();
  const [state, dispatch] = useReducer<Reducer<IThemeState, ThemeAction>>(
    ThemeReducer,
    getInitialThemeState()
  );

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.THEME, JSON.stringify(state));
    i18n.changeLanguage(state.language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const value = { state, dispatch };
  return (
    <ThemeContext.Provider value={value}>
      {props.children}
    </ThemeContext.Provider>
  );
};

export function useThemeContext() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("usethemeContext must be used within a AppProvider");
  }
  return context;
}
